export default "__VITE_ASSET__RMEXMCe3__"